











































import { Component, Mixins } from "vue-property-decorator";
import { CacheableComponent } from "../../../../../../base/components/system";
import {
  ModelEditableMixin,
  TabContainableMixin,
} from "../../../../../../base/components/system/mixins";
import { TabSelector } from "../../../../../../base/components/system/selectors";
import { IConfiguration } from "../../../../../domain/configuration";
import { default as FormatPropertyQuestionnaireEditTool } from "./FormatPropertyQuestionnaireEditTool.vue";
import { default as FormatPropertyGeneralEditTool } from "./FormatPropertyGeneralEditTool.vue";
import { default as FormatPropertyReferenceFileEditTool } from "./FormatPropertyReferenceFileEditTool.vue";
import { default as FormatPropertyLimitEditTool } from "./FormatPropertyLimitEditTool.vue";
import { default as FormatPropertyWorkflowEditTool } from "./FormatPropertyWorkflowEditTool.vue";

interface ITabDefinition {
  name: string;
  title: string;
  description: string;
}

@Component({
  components: {
    CacheableComponent,
    TabSelector,
    FormatPropertyQuestionnaireEditTool,
    FormatPropertyGeneralEditTool,
    FormatPropertyReferenceFileEditTool,
    FormatPropertyLimitEditTool,
    FormatPropertyWorkflowEditTool,
  },
})
export default class FormatPropertyEditTool extends Mixins(ModelEditableMixin, TabContainableMixin) {
  static readonly Tabs = {
    general: {
      name: "general",
      title: "全般",
      description: "属性全般を編集します。",
    },
    referenceFile: {
      name: "referenceFile",
      title: "説明資料",
      description: "説明資料を一覧表示します。追加/削除できます。",
    },
    limit: {
      name: "limit",
      title: "文書の制限",
      description: "文書の制限を編集します。",
    },
    workflow: {
      name: "workflow",
      title: "ワークフローの設定",
      description: "ワークフローの設定を編集します。",
    },
  };

  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly generalTab: ITabDefinition = FormatPropertyEditTool.Tabs.general;
  readonly referenceFileTab: ITabDefinition = FormatPropertyEditTool.Tabs.referenceFile;
  readonly limitTab: ITabDefinition = FormatPropertyEditTool.Tabs.limit;
  readonly workflowTab: ITabDefinition = FormatPropertyEditTool.Tabs.workflow;

  $configuration!: IConfiguration;

  get configuration() {
    return this.$configuration.formatEditor.behavior.format.editor;
  }

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable;
  }

  created(): void {
    // this.setLimitTabSetting(); // limitTabにワーディング適用
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = [
      this.generalTab,
      this.isQuestionnaireEditable ? null : this.referenceFileTab,
//      this.limitTab,  // TODO: 必要な案件までに対応.
      this.configuration.workflow.isEnable ? this.workflowTab : null,
    ].filter(t => !!t);
    this.selectedTab = this.generalTab;
  }

  setLimitTabSetting(): void {
    FormatPropertyEditTool.Tabs.limit.title = this.$wording.format.attributes.name + "の制限";
    FormatPropertyEditTool.Tabs.limit.description = this.$wording.format.attributes.name + "の制限を編集します。";
  }
}
